/* eslint-disable no-console, eol-last, import/no-duplicates,  import/no-extraneous-dependencies, import/order */
import '@interactjs/inertia/plugin'
import interact from '@interactjs/interact/index'
import plugin from '@interactjs/inertia/plugin'
interact.use(plugin)